import * as RX from 'reactxp';

import Banner from '../../components/banner';
import ButtonLink from '../../components/button_link';
import ExternalLink from '../../components/external_link';
import YellowExclamation from '../../components/yellow_exclamation';
import * as ReactGA from '../../modules/google_analytics';
import { Window } from '../../reducers/window';
import { applyBreakpoints, md } from '../../utils/breakpoints';
import t from '../../utils/i18n';
import { mapStateToProps } from '../../utils/mapper';
import { colors } from '../../utils/styles';
import { urls } from '../../utils/urls';

import { connect } from 'react-redux';
import { openUrl } from '../../modules/links/index';

interface HomePageProps {
  symptomChecker: () => void;
  window: Window & { multiplier: number };
}

const styles = (multiplier) => ({
  bannerText: RX.Styles.createViewStyle({
    padding: 12 * multiplier
  }),
  bottom: RX.Styles.createViewStyle({
    alignItems: 'center',
    position: 'absolute',
  }),
  header: RX.Styles.createTextStyle({
    color: colors.primary,
    fontSize: 58 * multiplier,
    fontWeight: 'bold',
    // position: 'absolute',
  }),
  headerMobile: RX.Styles.createTextStyle({
    color: colors.primary,
    fontSize: 48 * multiplier,
    fontWeight: 'bold',
    // position: 'absolute',
  }),
  outer: RX.Styles.createViewStyle({
    flex: 1,
  }),
  redCircle: RX.Styles.createViewStyle({
    alignItems: 'center',
    backgroundColor: colors.white,
    borderRadius: 18 * multiplier,
    height: 18 * multiplier,
    justifyContent: 'center',
    width: 18 * multiplier,
  }),
  x: RX.Styles.createTextStyle({
    color: colors.alert,
    fontSize: 12 * multiplier,
    fontWeight: '600',
  }),
});

const RedCircle = ({ text, width, multiplier }: { text: string, width: number, multiplier: number }) =>
  <RX.View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 16 * multiplier }}>
    <RX.View style={styles(multiplier).redCircle}><RX.Text style={styles(multiplier).x}>X</RX.Text></RX.View>
    <RX.Text
      style={{
        color: colors.white,
        fontSize: 18 * multiplier,
        marginLeft: 8 * multiplier,
        maxWidth: width - (26 - 152 * multiplier)
      }}
    >
      {text}
    </RX.Text>
  </RX.View>

class HomePage extends RX.Component<HomePageProps, RX.CommonProps &
{ textTop: number | undefined, showBanner: boolean, buttonsTop: number }> {

  constructor(props: HomePageProps) {
    super(props);
    this.state = {
      buttonsTop: 0,
      showBanner: true,
      textTop: undefined,
    };
  }

  public componentDidMount() {
    ReactGA.trackEvent(
      'Go to Home',
      'Navigation',
    );
  }

  public render() {
    const { window: { height, width, multiplier, landscape } } = this.props;

    return (
      <RX.View
        style={[
          styles(multiplier).outer,
          { width },
          ...applyBreakpoints(width, {
            lg: {
              alignItems: 'center',
              backgroundColor: colors.background,
              display: 'flex',
            },
            md: {
              minWidth: 400
            }
          })
        ]}
      >
        <RX.View
          style={[
            height && { height: (height - 110) / 4 * 3, minHeight: 630 * multiplier },
            {
              backgroundColor: '#e3f2f9'
            },
            ...applyBreakpoints(width, {
              lg: { maxWidth: 1200 },
              md: 635,
            })
          ]}
        >
          {RX.Platform.getType() !== 'web' ?
            <RX.Image
              style={{ height }}
              source={require('../../assets/mobile_background.png')}
              resizeMode='stretch' />
            : <img
              src={width >= md ?
                require('../../assets/main_background.png')
                : require('../../assets/WDIGFC App_images_stethoscope_992x896.jpg')}
                // tslint:disable:max-line-length
              style={{ minHeight: 350 * multiplier, height: '100%', width: width >= 1200 ? 1200 : width, visibility: width < md ? 'hidden' : 'visible' }}
            />}
          <RX.View
            style={[
              styles(multiplier).header,
              {
                transform: [{ translateY: -50 }]
              },
              height && {
                alignItems: 'end',
                height: RX.Platform.getType() !== 'web' ?
                    height : (multiplier > 1) ? (height ) / 4 * 3 : (height - 130) / 4 * 3,
                justifyContent: RX.Platform.getType() !== 'web' ? 'center' : 'space-around',
                minHeight: 650 * multiplier,
                // paddingLeft: multiplier > 1 ? 40 : 0,
                position: 'absolute',
                textAlign: 'center',
                top: RX.Platform.getType() !== 'web' && landscape ? 60 : 0,
                width,
              },
              ...applyBreakpoints(width, {
                md: RX.Styles.createTextStyle({
                  marginLeft: 150 * multiplier,
                  marginTop: 50,
                  maxWidth: 650 * multiplier,
                  textAlign: 'left'
                })
              }),
            ]}
          >
            <RX.View style={[...applyBreakpoints(width, {
              md: RX.Styles.createViewStyle({ alignItems: 'center', maxWidth: 350 * multiplier }),
              sm: RX.Styles.createViewStyle({alignItems: 'center' })
            })
      ]}>
              <RX.Animated.Text
                style={[
                  (multiplier > 1 ) ? styles(multiplier).headerMobile : styles(multiplier).header,
                  { maxWidth: width * multiplier, textAlign: 'center', paddingLeft: multiplier > 1 ? 20 : 0 },
                  ...applyBreakpoints(width, {
                    md: RX.Styles.createTextStyle({
                      maxWidth: 350 * multiplier,
                      textAlign: 'left'
                    })
                  }),
                ]}>
                {t('landingPage.header')}
              </RX.Animated.Text>
              <RX.Text style={[{
                color: colors.grey,
                fontSize: 20 * multiplier,
                fontWeight: 'bold',
                marginBottom: 12 * multiplier,
                marginTop: 12 * multiplier,
                paddingLeft: 8 * multiplier,
                paddingRight: 8 * multiplier,
              },
              { maxWidth: width - 24 * multiplier, textAlign: 'center' },
              ...applyBreakpoints(width, {
                md: RX.Styles.createTextStyle({
                  maxWidth: 350 * multiplier,
                  paddingLeft: 0,
                  paddingRight: 0,
                  textAlign: 'left',
                })
              })]}>
                {t('landingPage.subheader')}
              </RX.Text>
            </RX.View>
            <RX.View style={[
              { alignItems: 'center', marginTop: 80, width },
              ...applyBreakpoints(width, {
                md: RX.Styles.createViewStyle({
                  alignItems: 'stretch',
                  flex: 1,
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  width: 650 * multiplier,
                })
              }),
            ]}>
              <RX.View style={{ width: 300 * multiplier }}>
                <ButtonLink dark text={t('landingPage.checkSymptoms')} destination='/symptom-checker' />
              </RX.View>
              <RX.View style={{ width: 300 * multiplier, paddingTop: 20 }}>
                <ExternalLink
                  dark
                  left
                  locText={t('external.scheduling')}
                  text={t('landingPage.schedule')}
                  destination={urls.primaryCare}
                />
              </RX.View>
              {/* {//TODO Remove comment when apps are in the app store
            this.webPlatform && <RX.View style={{ flexDirection: 'row' }}>
              <RX.Button testId='appleStore' onPress={() => { }} style={{ paddingLeft: 0 }}>
                <RX.Image
                  style={{ height: 37 * multiplier, width: 112 * multiplier }}
                  resizeMode='cover'
                  source={require('../../assets/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg')} />
              </RX.Button>
              <RX.Button testId='googleStore' onPress={() => { }}>
                <RX.Image
                  style={{ height: 52 * multiplier, width: 118 * multiplier }}
                  resizeMode='cover'
                  source={require('../../assets/google-play-badge.png')} />
              </RX.Button>
            </RX.View>} */}
            </RX.View>
          </RX.View>
        </RX.View>
        <Banner>
          <RX.View style={[{
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
            padding: 16 * multiplier,
            paddingHorizontal: landscape ? 32 * multiplier : 16
          },
          ...applyBreakpoints(width, { md: { justifyContent: 'center' } }),
          ]}>
            <YellowExclamation smallHide />
            <RX.View style={[
              { marginLeft: 0, maxWidth: width - (40 * multiplier) },
              ...applyBreakpoints(width, { md: { maxWidth: width - 152, marginLeft: 32 } })
            ]}>
              <RX.Text style={[
                { color: colors.white, fontSize: 22 * multiplier, marginBottom: 16, maxWidth: width - 40 },
                ...applyBreakpoints(width, { md: { maxWidth: width } })
              ]}>
                {t('landingPage.banner.call')}
                <RX.Link
                  onPress={() => {
                    ReactGA.trackEvent(
                      'Call 911',
                      'Navigation',
                    );
                    openUrl('tel:911', '_blank');
                  }
                  }
                  style={{ textDecorationLine: 'underline', color: colors.white }}
                  url='tel:911'>{t('landingPage.banner.number')}</RX.Link> {t('landingPage.banner.emergencyDepartment')}
              </RX.Text>
              <RX.View style={[
                { flexDirection: 'column', justifyContent: 'space-between' },
                ...applyBreakpoints(width, { md: { flexDirection: 'row' } })
              ]}>
                <RX.View>
                  <RedCircle text={t('landingPage.banner.chest')} {... { width, multiplier }} />
                  <RedCircle text={t('landingPage.banner.difficulty')} {... { width, multiplier }} />
                </RX.View>
                <RX.View>
                  <RedCircle text={t('landingPage.banner.cough')} {... { width, multiplier }} />
                  <RedCircle text={t('landingPage.banner.vomit')} {... { width, multiplier }} />
                </RX.View>
                <RX.View>
                  <RedCircle text={t('landingPage.banner.bone')} {... { width, multiplier }} />
                </RX.View>
              </RX.View>
            </RX.View>
          </RX.View>
        </Banner>
      </RX.View>
    );
  }
}

export default connect(mapStateToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/pages/home/index.tsx